import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FirstPasswordModalComponent } from 'src/app/components/first-password-modal/first-password-modal.component';
import { CustomerServiceDialogComponent } from 'src/app/components/page/customer-service-dialog/customer-service-dialog.component';
import { ChoiceProcessModalComponent } from 'src/app/components/presales-aftersales/choice-process-modal/choice-process-modal.component';
import { TipModalComponent } from 'src/app/components/tip-modal/tip-modal.component';
import { UserApiService } from 'src/app/services/api/user-api.service';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
})
export class MainPageComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    public router: Router,
    private api: UserApiService,
  ) {}

  showCustomerService() {
    this.dialog.open(ChoiceProcessModalComponent, {
      width: '471px',
    });
  }

  ngOnInit(): void {
    // this.dialog.open(TipModalComponent, {
    //   panelClass: 'tip-dialog',
    // });

    if (sessionStorage.getItem('showFirstPasswordModal') === '1') {
      sessionStorage.removeItem('showFirstPasswordModal');
      this.dialog
        .open(FirstPasswordModalComponent, {
          panelClass: 'app-dialog',
          width: '400px',
        })
        .afterClosed()
        .subscribe((r) => {
          this.getKnowPasswordChange();
        });
    }
  }

  async getKnowPasswordChange() {
    try {
      const r = await this.api.getKnowPasswordChange();
    } catch (error) {}
  }
}
